export const REDACTED_PLACEHOLDER = '<REDACTED>';
const SENSITIVE_HEADER_NAMES = new Set([
    'authorization',
    'proxy-authorization',
    'proxy-authentication',
    'x-api-key',
    'x-api-token',
    'x-auth-token',
    'api-key',
    'api_key',
    'proxy_key',
    'cookie',
    'set-cookie',
]);
export function redactMessage(message) {
    if (message.payload == null) {
        return { redacted: message, count: 0 };
    }
    const { value, count } = redactValue(message.payload, { inProxyConfig: false });
    if (count === 0) {
        return { redacted: message, count: 0 };
    }
    const redactedPayload = value;
    return {
        redacted: {
            ...message,
            payload: redactedPayload,
            raw: JSON.stringify(redactedPayload),
        },
        count,
    };
}
function redactValue(value, ctx) {
    if (Array.isArray(value)) {
        let count = 0;
        const out = new Array(value.length);
        for (let i = 0; i < value.length; i++) {
            const r = redactValue(value[i], ctx);
            out[i] = r.value;
            count += r.count;
        }
        return { value: out, count };
    }
    if (value !== null && typeof value === 'object') {
        let count = 0;
        const out = {};
        for (const [k, v] of Object.entries(value)) {
            if (typeof v === 'string' && SENSITIVE_HEADER_NAMES.has(k.toLowerCase())) {
                out[k] = REDACTED_PLACEHOLDER;
                count += 1;
                continue;
            }
            if (ctx.inProxyConfig &&
                k === 'headers' &&
                v !== null &&
                typeof v === 'object' &&
                !Array.isArray(v)) {
                const r = redactHeadersBlock(v);
                out[k] = r.value;
                count += r.count;
                continue;
            }
            const childCtx = ctx.inProxyConfig || k.toLowerCase() === 'proxyconfig'
                ? { inProxyConfig: true }
                : ctx;
            const r = redactValue(v, childCtx);
            out[k] = r.value;
            count += r.count;
        }
        return { value: out, count };
    }
    return { value, count: 0 };
}
function redactHeadersBlock(obj) {
    let count = 0;
    const out = {};
    for (const [k, v] of Object.entries(obj)) {
        if (typeof v === 'string') {
            out[k] = REDACTED_PLACEHOLDER;
            count += 1;
        }
        else {
            out[k] = v;
        }
    }
    return { value: out, count };
}
export function redactSessionExport(exp) {
    let messagesAffected = 0;
    let fieldsRedacted = 0;
    const messages = exp.messages.map((msg) => {
        const r = redactMessage(msg);
        if (r.count > 0) {
            messagesAffected += 1;
            fieldsRedacted += r.count;
        }
        return r.redacted;
    });
    if (fieldsRedacted === 0) {
        return { export: exp, messagesAffected: 0, fieldsRedacted: 0 };
    }
    return {
        export: { ...exp, messages },
        messagesAffected,
        fieldsRedacted,
    };
}
//# sourceMappingURL=redact.js.map